import React from 'react';
import { Box, Container, Typography, Button, Paper } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import SearchIcon from '@mui/icons-material/Search';

const NotFound = () => {
  return (
    <Box sx={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      bgcolor: '#f5f5f5',
      py: 4
    }}>
      <Container maxWidth="md">
        <Paper 
          elevation={1} 
          sx={{ 
            py: 6, 
            px: 4, 
            textAlign: 'center',
            borderRadius: 2
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 70, color: '#1976d2', mb: 2 }} />
          
          <Typography variant="h4" component="h1" gutterBottom>
            404 - Page Not Found
          </Typography>
          
          <Typography variant="body1" color="text.secondary" paragraph>
            The page you are looking for doesn't exist or has been moved.
          </Typography>
          
          <Box sx={{ mt: 4 }}>
            <Button
              variant="contained"
              color="primary"
              component={RouterLink}
              to="/"
              startIcon={<SearchIcon />}
              sx={{ 
                height: '48px',
                borderRadius: '4px'
              }}
            >
              Back to Certificate Verification
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default NotFound;
